import { AutoMap } from "@automapper/classes"

export class AgencyDTO {
    @AutoMap()
    name!: string;
    @AutoMap()
    email!: string;
    @AutoMap()
    dispatchEmail!: string;
    @AutoMap()
    partnerCode!: string;
    @AutoMap()
    analyticalUnitCode!: string;
    @AutoMap()
    address!: string;
    @AutoMap()
    zipCode!: string;
    @AutoMap()
    city!: string;
    @AutoMap()
    phone!: string;
    @AutoMap()
    partnerName!: string;
}